import PropTypes from 'prop-types';
import React from 'react';
import Text from '@loggi/ui/components/text';
import Icon from '@loggi/ui/components/icon';
import classNames from 'classnames';

const SelectPlaceholder = ({ icon, label }) => {
  const iconClasses = classNames(['Select-icon', 'text-lg']);
  return (
    <Text>
      {icon && <Icon className={iconClasses} type={icon} />}
      {label}
    </Text>
  );
};

SelectPlaceholder.propTypes = {
  option: PropTypes.object.isRequired
};

SelectPlaceholder.displayName = 'SelectPlaceholder';

export default SelectPlaceholder;
